import { render, staticRenderFns } from "./loader-btn.vue?vue&type=template&id=286d398c&"
import script from "./loader-btn.vue?vue&type=script&lang=js&"
export * from "./loader-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports